<template>
  <nav
    v-if="isAuthenticated"
    class="navbar has-shadow is-light"
    role="navigation"
    aria-label="main navigation">

    <div class="navbar-brand">
      <router-link 
        :to="{ name: 'Home' }" 
        class="navbar-item is-hoverable px-2 py-0"
        exact-active-class="is-active">
        <img 
          src="@/assets/mitrex_and_cladify_logo.png" 
          width="auto" 
        >
      </router-link>

      <a 
        role="button" 
        class="navbar-burger burger" 
        :class="{ 'is-active': active }"
        aria-label="menu" 
        aria-expanded="false"
        @click="active = !active">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>


    <div 
      class="navbar-menu" 
      :class="{ 'is-active': active }"
      @click="active = !active"
      v-if="$route.name != 'ProposalMaker'">
      <div class="navbar-start">

        <div
          class="navbar-item has-dropdown is-hoverable"
          v-if="show.ticketing">

          <a 
            class="navbar-item"
            :class="{ 'is-active': ['Tickets', 'TicketCompanies', 'TicketContacts']
              .includes($route.name) }">
            Tickets
          </a>

          <div class="navbar-dropdown">
            <router-link
              :to="{ name: 'Tickets' }"
              class="navbar-item"
              exact-active-class="is-active">
              Tickets
            </router-link>
            <hr class="dropdown-divider">
            <router-link
              :to="{ name: 'TicketCompanies' }"
              class="navbar-item"
              exact-active-class="is-active">
              Companies
            </router-link>
            <router-link
              :to="{ name: 'TicketContacts' }"
              class="navbar-item"
              exact-active-class="is-active">
              Contacts
            </router-link>
          </div>
        </div>

        <router-link
          v-else
          class="navbar-item is-hoverable"
          :to="{ name: 'Tickets' }"
          exact-active-class="is-active">
          Ticketing
        </router-link>

        <div
          v-if="show.samples"
          class="navbar-item has-dropdown is-hoverable">

          <a 
            class="navbar-item"
            :class="{ 'is-active': ['Samples', 'SampleRequests', 'SampleRequestMaker']
              .includes($route.name) }">
            Samples
          </a>

          <div class="navbar-dropdown">
            <router-link
              :to="{ name: 'SampleRequests' }"
              class="navbar-item"
              exact-active-class="is-active">
              Requests
            </router-link>
            <router-link
              :to="{ name: 'Samples' }"
              class="navbar-item"
              exact-active-class="is-active">
              Samples
            </router-link>
          </div>
        </div>

        <div class="navbar-item has-dropdown is-hoverable">

          <a 
            class="navbar-item"
            :class="{ 'is-active': $route.name == 'Documents' }">
            Documents
          </a>

          <div class="navbar-dropdown">
            <template v-for="documentType in documentTypes">
              <router-link
                v-if="show.documents[documentType.id]"
                :key="documentType.id"
                :to="{ name: 'Documents', params: { documentTypeId: documentType.id } }"
                class="navbar-item"
                exact-active-class="is-active">
                {{ documentType.type_name }}
              </router-link>
            </template>
            <!-- <hr class="dropdown-divider">
            <a 
              class="navbar-item" 
              @click="managingDocumentTypes = true">
              Document Types
            </a> -->
          </div>
        </div>

        <div
          v-if="show.estimations" 
          class="navbar-item has-dropdown is-hoverable">
          <a 
            class="navbar-item"
            :class="{ 'is-active': ['RFQs','Estimations','EstimationDashboard'].includes($route.name) }">
            Estimations
          </a>

          <div class="navbar-dropdown">
            <router-link
              :to="{ name: 'EstimationDashboard' }"
              class="navbar-item"
              exact-active-class="is-active">
              Dashboard
            </router-link>
            <hr class="dropdown-divider">
            <router-link
              :to="{ name: 'RFQs' }"
              class="navbar-item"
              exact-active-class="is-active">
              RFQs
            </router-link>
            <router-link
              :to="{ name: 'DrawingHighlights' }"
              class="navbar-item"
              exact-active-class="is-active">
              Drawing Highlights
            </router-link>
            <router-link
              :to="{ name: 'Estimations'}"
              class="navbar-item"
              exact-active-class="is-active">
              Estimations
            </router-link>
            <hr class="dropdown-divider">
            <a
              @click="managingRfqDocumentTypes = true"
              class="navbar-item">
              RFQ Document Types
            </a>
            <a 
              class="navbar-item" 
              @click="managingDefaultParams = true">
              Estimation Parameters
            </a>
            <!-- <router-link
              :to="{ name: 'Materials' }"
              class="navbar-item"
              exact-active-class="is-active">
              Materials
            </router-link> -->
            <a
              @click="managingProcessingMethods = true"
              class="navbar-item">
              Processing Methods
            </a>
            <a
              @click="managingFabrications = true"
              class="navbar-item">
              Fabrications
            </a>
            <a
              @click="managingServices = true"
              class="navbar-item">
              Services
            </a>
            <router-link
              :to="{ name: 'InstallationMethods' }"
              exact-active-class="is-active"
              class="navbar-item">
              Installations
            </router-link>
            <a
              @click="managingElevations = true"
              class="navbar-item">
              Elevations
            </a>
            <a
              @click="managingUnits = true"
              class="navbar-item">
              Units
            </a>
          </div>
        </div>

        <div
          v-if="show.proposals" 
          class="navbar-item has-dropdown is-hoverable">
          <a 
            class="navbar-item"
            :class="{ 'is-active': $route.name == 'Proposals' }">
            Proposals
          </a>

          <div class="navbar-dropdown">
            <router-link
              :to="{ name: 'Proposals', params: { product: 'Cladify' }}"
              class="navbar-item"
              exact-active-class="is-active">
              Cladify
            </router-link>
            <router-link
              :to="{ name: 'Proposals', params: { product: 'Mitrex' }}"
              class="navbar-item"
              exact-active-class="is-active">
              Mitrex
            </router-link>
          </div>
        </div>

        <div
          v-if="show.design"  
          class="navbar-item has-dropdown is-hoverable">
          <a 
            class="navbar-item"
            :class="{ 'is-active': ['ProductionSheets','CutSheets','AssemblyList','Products']
              .includes($route.name) }">
            Design
          </a>

          <div class="navbar-dropdown">
            <router-link
              :to="{ name: 'ProductionSheets' }"
              class="navbar-item"
              exact-active-class="is-active">
              Slab Production Sheets
            </router-link>
            <router-link
              :to="{ name: 'CutSheets' }"
              class="navbar-item"
              exact-active-class="is-active">
              Cut Sheets
            </router-link>
            <router-link
              :to="{ name: 'AssemblyList' }"
              class="navbar-item"
              exact-active-class="is-active">
              Assembly
            </router-link>
            <hr class="dropdown-divider">
            <router-link
              :to="{ name: 'Products' }"
              class="navbar-item"
              exact-active-class="is-active">
              Products
            </router-link>
            <a 
              class="navbar-item" 
              @click="managingSteps = true">
              Cut Sheet Steps
            </a>
          </div>
        </div>

        
        <div
          v-if="show.production"  
          class="navbar-item has-dropdown is-hoverable">
          <a 
            class="navbar-item"
            :class="{ 'is-active': ['StorageList','ScheduleMaker','ProductionStatus',
              'ProductionTaskManagement', 'Workstations', 'WorkSteps'].includes($route.name) }">
            Production
          </a>

          <div class="navbar-dropdown">
            <router-link
              :to="{ name: 'StorageList' }"
              class="navbar-item"
              exact-active-class="is-active">
              Packing
            </router-link>
            <router-link
              :to="{ name: 'ScheduleMaker' }"
              class="navbar-item"
              exact-active-class="is-active">
              Production Scheduler
            </router-link>
            <router-link
              :to="{ name: 'ProductionStatus' }"
              class="navbar-item"
              exact-active-class="is-active">
              Production Status
            </router-link>
            <router-link
              :to="{ name: 'ProductionTaskManagement' }"
              class="navbar-item"
              exact-active-class="is-active">
              Production Task Management
            </router-link>
            <hr class="dropdown-divider">
            <router-link
              :to="{ name: 'Workstations' }"
              class="navbar-item"
              exact-active-class="is-active">
              Workstations
            </router-link>
            <router-link
              :to="{ name: 'WorkSteps' }"
              class="navbar-item"
              exact-active-class="is-active">
              Work Steps
            </router-link>
          </div>
        </div>
        
        <div
          class="navbar-item has-dropdown is-hoverable"
          v-if="show.inventory">

          <a 
            class="navbar-item"
            :class="{ 'is-active': ['ProductionSheetItems','Boms','Orders',
              'InventoryManagement', 'Suppliers'].includes($route.name) }">
            Inventory
          </a>

          <div class="navbar-dropdown">
            <router-link
              :to="{ name: 'ProductionSheetItems' }"
              class="navbar-item"
              exact-active-class="is-active">
              Slabs
            </router-link>
            <router-link
              :to="{ name: 'Boms' }"
              class="navbar-item"
              exact-active-class="is-active">
              BOMs
            </router-link>
            <router-link
              :to="{ name: 'Orders' }"
              class="navbar-item"
              exact-active-class="is-active">
              Orders
            </router-link>
            <router-link
              :to="{ name: 'InventoryManagement' }"
              class="navbar-item"
              exact-active-class="is-active">
              Inventory Management
            </router-link>
            <hr class="dropdown-divider">
            <router-link
              :to="{ name: 'Suppliers' }"
              class="navbar-item"
              exact-active-class="is-active">
              Suppliers
            </router-link>
          </div>
        </div>

        <router-link
          v-if="show.warehousing"
          class="navbar-item is-hoverable"
          :to="{ name: 'WarehouseLocations' }"
          exact-active-class="is-active">
          Warehouses
        </router-link>

        <!-- <router-link
          v-if="show.deliveries"
          class="navbar-item is-hoverable"
          :to="{ name: 'DeliveryList' }"
          exact-active-class="is-active">
          Deliveries
        </router-link> -->

        <div
          class="navbar-item has-dropdown is-hoverable"
          v-if="show.installation">

          <a 
            class="navbar-item"
            :class="{ 'is-active': [
              'SkidList','SkidViewer','InstallationItems', 'InstallationSummary'
            ].includes($route.name) }">
            Installation
          </a>

          <div class="navbar-dropdown">
            <router-link
              v-if="show.installationSummary"
              :to="{ name: 'InstallationSummary' }"
              class="navbar-item"
              exact-active-class="is-active">
              Installation Summary
            </router-link>
            <router-link
              v-if="show.installationProjects"
              :to="{ name: 'InstallationProjects' }"
              class="navbar-item"
              exact-active-class="is-active">
              Installation Projects
            </router-link>
            <router-link
              v-if="show.installationDefectedProjects"
              :to="{ name: 'InstallationDefectedProjects' }"
              class="navbar-item"
              exact-active-class="is-active">
              Defected Pieces Summary
            </router-link>
            <!-- <router-link
              :to="{ name: 'SkidList' }"
              class="navbar-item"
              exact-active-class="is-active">
              Skids
            </router-link>
            <router-link
              :to="{ name: 'InstallationItems' }"
              class="navbar-item"
              exact-active-class="is-active">
              Installation Items
            </router-link> -->
          </div>
        </div>

      </div>

      <div class="navbar-end">
        <div class="navbar-item">
          <div class="buttons">
            <a
              v-if="isAuthenticated && ![
                'CutSheetViewer', 'AssemblyView', 'OrderViewer', 'BomViewer', 'SkidViewer'
              ].includes($route.name)"
              @click="logout()"
              class="button is-primary">
              Log out
            </a>
            <a
              v-if="isAuthenticated && user.sign_in_method == 'email'"
              @click="setChangingPassword(true)"
              class="button">
              <span class="icon">
                <i class="fas fa-key"></i>
              </span>
            </a>
            <button
              v-if="$route.name == 'CutSheetViewer'"
              class="button is-link"
              title="Print Cut Sheet"
              aria-label="Print Cut Sheet"
              @click="print()">
              <span class="icon is-medium">
                <i class="fas fa-print"></i>
              </span>
              <span>Print Cut Sheet</span>
            </button>
            <button
              v-if="$route.name == 'AssemblyView'"
              class="button is-link"
              title="Print Assembly Sheet"
              aria-label="Print Assembly Sheet"
              @click="print()">
              <span class="icon is-medium">
                <i class="fas fa-print"></i>
              </span>
              <span>Print Assembly Sheet</span>
            </button>
            <button
              v-if="$route.name == 'OrderViewer'"
              class="button is-link"
              title="Print Order"
              aria-label="Print Order"
              @click="print()">
              <span class="icon is-medium">
                <i class="fas fa-print"></i>
              </span>
              <span>Print Order</span>
            </button>
            <button
              v-if="$route.name == 'BomViewer'"
              class="button is-link"
              title="Print BOM"
              aria-label="Print BOM"
              @click="print()">
              <span class="icon is-medium">
                <i class="fas fa-print"></i>
              </span>
              <span>Print BOM</span>
            </button>
            <button
              v-if="$route.name == 'SkidViewer'"
              class="button is-link"
              title="Print Skid"
              aria-label="Print Skid"
              @click="print()">
              <span class="icon is-medium">
                <i class="fas fa-print"></i>
              </span>
              <span>Print Skid</span>
            </button>

            <router-link 
              v-if="isAuthenticated && user.permission === 'admin' && user.role === 'developer'"
              :to="{ name: 'UserList' }"
              class="button">
              <span class="icon">
                <i class="fas fa-cogs"></i>
              </span>
            </router-link>
  
          </div>
        </div>
      </div>
    </div>

    <div class="navbar-menu" v-if="$route.name == 'ProposalMaker'">
      <div class="navbar-start">
        <nav 
          v-if="project" 
          class="breadcrumb mb-0 pl-3" 
          aria-label="breadcrumbs">
          <ul class="flex flex--row flex--align-center">
            <li>
              <router-link  
                :to="{ 
                  name: 'Proposals', 
                  params: { product: project.product_brand }}">
                {{ project.product_brand }} Proposals
              </router-link>
            </li>
            <li>
              <v-label
                :key="proposal.id"
                v-if="proposal"
                class="proposal__title ml-2 my-1 py-2 px-2"
                :text="proposal.proposal_object.name"
                :editable="true"
                @update="updateName"
              >
              </v-label>
              <span 
                class="tag is-primary is-light ml-2" 
                v-if="proposal && proposal.proposal_object.proposal_type === CONDENSED"
              >
                Condensed Proposal
              </span>
            </li>
          </ul>
        </nav>
      </div>

      <div class="navbar-end">
        <div class="buttons pr-3">
          <button
            class="button"
            :class="{ 'is-loading': syncing }"
            title="Sync with CRM"
            @click="sync(proposal.proposal_object.project_crm_id)">
            <span class="icon is-medium">
              <i class="fas fa-sync-alt"></i>
            </span>
            <span>Sync with CRM</span>
          </button>

          <v-fade-transition mode="out-in">
            <button
               v-if="rfq && rfq.drawing_highlights.length > 0 && 
                rfq.drawing_highlights[0].drawing_svg"
              class="button is-primary"
              title="Customer Portal Link"
              @click="custProposalLinkModal = true">
              <span class="icon is-medium">
                <i class="fas fa-link"></i>
              </span>
              <span>Customer Link</span>
            </button>
          </v-fade-transition>

          <button
            class="button is-link"
            title="Sync with CRM"
            @click="print()">
            <span class="icon is-medium">
              <i class="fas fa-print"></i>
            </span>
            <span>Print or Save as PDF</span>
          </button>

          <button
            class="button is-link"
            title="Save changes"
            aria-label="save changes"
            @click="incSaveCount">
            <span class="icon is-medium">
              <i class="far fa-save"></i>
            </span>
            <span>Save and Refresh</span>
          </button>
        </div>
      </div>
    </div>

    <manage-steps-modal 
      v-if="managingSteps"
      v-model="managingSteps"/>

    <manage-document-types-modal 
      v-if="managingDocumentTypes"
      v-model="managingDocumentTypes"/>

    <manage-default-parameters-modal 
      v-if="managingDefaultParams"
      v-model="managingDefaultParams"/>

    <manage-services-modal 
      v-if="managingServices"
      v-model="managingServices"/>

    <manage-installations-modal 
      v-if="managingInstallations"
      v-model="managingInstallations"/>

    <manage-fabrications-modal
      v-if="managingFabrications"
      v-model="managingFabrications"/>
    
    <manage-processing-methods-modal
      v-if="managingProcessingMethods"
      v-model="managingProcessingMethods"/>

    <manage-units-modal
      v-if="managingUnits"
      v-model="managingUnits"/>

    <manage-elevations-modal
      v-if="managingElevations"
      v-model="managingElevations"/>

    <manage-rfq-document-types-modal
      v-if="managingRfqDocumentTypes"
      v-model="managingRfqDocumentTypes"/>

    <change-password-modal 
      :value="changingPassword"
      @input="setChangingPassword"
      :allow-close="user.sign_in_count > 1"
      :title="user.sign_in_count > 1 ? 'Change Your Password' : 
        'Please Change Your Password'"/>

    <customer-proposal-link-modal
      v-if="custProposalLinkModal"
      v-model="custProposalLinkModal"/>
      
  </nav>
</template>

<script>
import ManageStepsModal from '@/components/cutsheet/ManageStepsModal'
import ManageDocumentTypesModal from '@/components/documents/ManageDocumentTypesModal'
import ManageDefaultParametersModal from '@/components/estimations/ManageDefaultParametersModal'
import ManageServicesModal from '@/components/estimations/ManageServicesModal'
import ManageFabricationsModal from '@/components/estimations/ManageFabricationsModal'
import ManageProcessingMethodsModal from '@/components/estimations/ManageProcessingMethodsModal'
import ManageUnitsModal from '@/components/estimations/ManageUnitsModal'
import ManageElevationsModal from '@/components/estimations/ManageElevationsModal'
import ManageRfqDocumentTypesModal from '../rfq/ManageRfqDocumentTypesModal.vue'
import ManageInstallationsModal from '../estimations/ManageInstallationsModal.vue'
import ChangePasswordModal from '@/components/user/ChangePasswordModal'
import CustomerProposalLinkModal from '@/components/proposalmaker/CustomerProposalLinkModal'

import VLabel from '@/components/base/VLabel'
import VFadeTransition from '@/components/transitions/VFadeTransition'

import { CONDENSED } from '@/helpers/constants'

import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  components: { 
    ManageStepsModal, 
    ManageDocumentTypesModal, 
    ManageDefaultParametersModal, 
    ManageServicesModal,
    ManageFabricationsModal,
    ManageProcessingMethodsModal,
    ManageUnitsModal,
    ManageElevationsModal,
    VLabel,
    VFadeTransition,
    ManageRfqDocumentTypesModal,
    ManageInstallationsModal,
    ChangePasswordModal,
    CustomerProposalLinkModal
  },
  data() {
    return {
      timeout: null,
      managingSteps: false,
      managingDocumentTypes: false,
      managingDefaultParams: false,
      managingServices: false,
      managingInstallations: false,
      managingFabrications: false,
      managingProcessingMethods: false,
      managingUnits: false,
      managingElevations: false,
      managingRfqDocumentTypes: false,
      custProposalLinkModal: false,
      active: false,
      CONDENSED: CONDENSED
    }
  },
  computed: {
    ...mapState("proposalMaker", ["project", "proposal", "syncing"]),
    ...mapState("rfq", ["rfq", "rfqLoading"]),
    ...mapState("auth", ["user", "changingPassword"]),
    ...mapState("documents", ["documentTypes"]),
    ...mapGetters("auth", ["isAuthenticated"]),
    show({ user }) {
      return {
        admin: user.permission == 'admin' && user.role == 'developer',
        estimations: ["developer", "estimator", "sales", "ceo", "sales-estimator", "sales-estimator-samples"].includes(user.role) || user.permission == 'admin',
        proposals: ["developer", "sales", "ceo", "sales-estimator", "sales-estimator-samples"].includes(user.role) || user.permission == 'admin',
        design: ["developer", "estimator", "ceo", "sales-estimator", "sales-estimator-samples"].includes(user.role) || user.permission == 'admin',
        ticketing: user.role == 'office-manager' || user.permission == 'admin',
        samples: ["sales", "office-manager", "ceo", "developer", "sales-estimator", "sales-estimator-samples"].includes(user.role) || user.permission == 'admin',
        documents: {
          2: ["sales", "ceo", "sales-estimator", "sales-estimator-samples"].includes(user.role) || user.permission == 'admin',
          3: true,
          6: true,
          7: ["sales", "ceo", "sales-estimator", "sales-estimator-samples"].includes(user.role) || user.permission == 'admin',
          8: true
        },
        inventory: ["developer", "estimator", "ceo", "production"].includes(user.role) || user.permission == 'admin',
        production: ["developer", "estimator", "ceo", "production"].includes(user.role) || user.permission == 'admin',
        warehousing: ["developer", "estimator", "ceo", "production"].includes(user.role) || user.permission == 'admin',
        deliveries: ["developer", "estimator", "ceo", "production"].includes(user.role) || user.permission == 'admin',
        installation: ["developer", "estimator", "ceo", "production", "office-manager", "installer", "project-manager"].includes(user.role) || user.permission == 'admin',
        installationProjects: ["developer", "ceo", "project-manager", "office-manager", "installer", "packing"].includes(user.role) || user.permission == 'admin',
        installationSummary: ["developer", "ceo", "project-manager"].includes(user.role) || user.permission == 'admin',
        installationDefectedProjects: ["developer", "ceo", "project-manager"].includes(user.role) || user.permission == 'admin'
      }
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("auth", ["authLogout"]),
    ...mapMutations("auth", ["setChangingPassword"]),
    ...mapActions("proposalMaker", ["sync"]),
    ...mapActions("documents", ["getDocumentTypes"]),
    ...mapMutations("proposalMaker", ["incSaveCount", "updateProposalName"]),
    initialize() {  
      if (this.documentTypes.length == 0) {
        this.getDocumentTypes();
      }
    },
    logout() {
      this.authLogout().then(() => {
        this.$router.push({ name: 'Authentication' });
      })
    },
    updateName(v) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.updateProposalName(v);
      }, 600);
    },
    print() {
      window.print();
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/flexbox.scss';

@media print {
  nav {
    display: none;
  }
}

.proposal__title {
  color: dimgray;
  font-weight: 600;
  font-size: 1.09em;
  min-width: 250px;
}

.navbar {
  height: 3rem;
  &.has-shadow {
    box-shadow: 0 1px 4px 0 rgba(21,27,38,.2);
  }
  .navbar-item.is-active {
    background: #e8e8e8 !important;
  }
}

.navbar-item {
  img {
    max-height: 45px;
  }
}
</style>
